import logo from '../assets/images/logo.png';

export const Logo = () => {
  return (
    <>
      <img src={logo} alt="logo" />
    </>
  );
};
